export type Wine = {
  _key: string
  name: string
  price?: number
}

export type Taster = {
  _key: string
  name: string
  scores: (number | null)[]
}

export type Tasting = {
  version: number
  _id: string
  _type?: 'tasting' // Set after first Sanity save
  theme: string
  host?: string
  date?: string // ISO date string (YYYY-MM-DD)
  wines: Wine[]
  tasters: Taster[]
  wineAssignments: (number | null)[] // letterIndex → wineIndex (or null if unassigned)
  hasUnsavedChanges: boolean
}

export const CURRENT_TASTING_VERSION = 3
